import { gql } from 'apollo-angular';
import { Template } from '../../entities/template/template';

export const TEMPLATES_QUERY = gql`
  query templatesQuery(
    $isCustomizable: Boolean
  ) {
    templates: getTemplates(
      templateFilter: {
        isCustomizable: $isCustomizable
      }
    ) {
     key
     name
     type
     templateVariants{
      id
      name
      htmlCode
      isSystem
      isActive
      isDeletable
      attachments {
        fileName
      }
     }
    }
  }
`;

export interface TemplatesQueryResponse {
  templates: Template[];
  loading: boolean;
}
